import { X } from "@phosphor-icons/react";
import { Button } from "./Button";

interface HelpfulTipsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function HelpfulTipsModal({ isOpen, onClose }: HelpfulTipsModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[var(--bg-default-overlay)]  backdrop-blur-md p-4">
      <div className="w-full max-w-md bg-[var(--bg-modal)] rounded-2xl p-6 shadow-xl relative">
        <button
          type="button"
          onClick={onClose}
          className="absolute right-4 top-4 text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors"
          aria-label="Close modal"
        >
          <X size={20} />
        </button>

        <h2 className="text-heading-modal mb-4">Helpful Tips</h2>

        <p className="text-body-small mb-6">
          Clear descriptors help IQ Design understand your vision. Below is a
          great place to start. Still not sure, check out our workflows on{" "}
          <a
            href="https://www.iqdesign.ai/learn"
            target="_blank"
            rel="noopener noreferrer"
            className="text-modal-support-link"
          >
            iqdesign.ai/learn
          </a>
          .
        </p>

        <div className="space-y-4">
          <div>
            <h3 className="text-label-field mb-2 text-[var(--text-primary)]">
              Style
            </h3>
            <div className="border-l-2 border-[var(--text-primary)] pl-3">
              <p className="text-body-small">
                Modern, minimalist, rustic, art deco, or something else?
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-label-field mb-2 text-[var(--text-primary)]">
              Material
            </h3>
            <div className="border-l-2 border-[var(--text-primary)] pl-3">
              <p className="text-body-small">
                Wood, metal, glass, fabric, with any specific texture or finish.
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-label-field mb-2 text-[var(--text-primary)]">
              Mood/Feeling
            </h3>
            <div className="border-l-2 border-[var(--text-primary)] pl-3">
              <p className="text-body-small">
                Sleek, cozy, bold, playful, or luxurious.
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-label-field mb-2 text-[var(--text-primary)]">
              Color Palette
            </h3>
            <div className="border-l-2 border-[var(--text-primary)] pl-3">
              <p className="text-body-small">
                Specific colors, tones, or contrasts you want highlighted.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-8 flex justify-end">
          <Button onClick={onClose} variant="primary">
            Ok
          </Button>
        </div>
      </div>
    </div>
  );
}
